// extracted by mini-css-extract-plugin
export default {"cnt":"style_cnt__XpRGv","left":"style_left__71KKp","left_value":"style_left_value__c2fCE","left_value_gray":"style_left_value_gray__Kl03f","right":"style_right__mU7xM"};